import { buildSectionRenameUpdate } from '@griply/services';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

import { useUpdateLifeArea } from './use-update-life-area';

export const useRenameLifeAreaSection = () => {
  const { submit: updateLifeArea } = useUpdateLifeArea();

  return useCallback(
    (lifeArea: LifeArea, sectionId: ID, name: string) => {
      if (!lifeArea.sections) {
        return;
      }

      updateLifeArea(buildSectionRenameUpdate(lifeArea, sectionId, name));
    },
    [updateLifeArea],
  );
};
